import type { ReactNode } from "react";
import ApprovalHistoryContent from "./ApprovalHistoryContent";
import ApprovalHistoryInput from "./ApprovalHistoryInput";

interface Props {
  children: ReactNode;
}

export const ApprovalHistory = (props: Props) => {
  const { children } = props;

  return (
    <div className="InputWraper">
      <div className="wraper">{children}</div>
    </div>
  );
};

ApprovalHistory.Content = ApprovalHistoryContent;
ApprovalHistory.Input = ApprovalHistoryInput;
